import { createAsyncThunk } from "@reduxjs/toolkit";
import apiConfig from "constants/apiConfig";
import { fetchCampaignPayments as fetchCampaignPaymentsAPI } from "services/api/campaign";
import { AuthState } from "slices/auth/reducer";
import { ERROR } from "types";
import { CampaignPayments, PaymentsResponse } from "types/campaign/payments";
import { getErrorMessage, isFresh } from "utils/helpers";

export const fetchCampaignPayments = createAsyncThunk<{campaignId: string, campaignPayment: PaymentsResponse}, {force?: boolean, campaignId: string}, {rejectValue: string}>(
    'campaign/payment',
    async ({force, campaignId}, {getState, rejectWithValue}) => {
        try {
            const STALE_TIME = apiConfig.FETCH_CAMPAIGN_PAYMENTS.staleTime;
            const state = getState() as {auth: AuthState, campaignPayments: CampaignPayments};
            const agencyId = state.auth.selectedAgencyId;
            if(!agencyId) throw new Error("No agency selected!");

            if(!force && isFresh(state.campaignPayments.campaigns[campaignId]?.last_fetched_at, STALE_TIME)){
                return rejectWithValue(ERROR.CACHED);
            }

            const campaignPayment = await fetchCampaignPaymentsAPI(agencyId, campaignId);

            return {campaignId, campaignPayment};

        } catch (error) {
            return rejectWithValue(getErrorMessage(error, "Failed to fetch campaign payment"));
        }
    }
)